import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

import type {
  ProductionHistoryCardState,
  ProductionHistoryRecord,
} from './assistant-models'


export default /*#__PURE__*/_defineComponent({
  __name: 'g-assistant-production-history-card',
  props: {
    state: null,
    records: { default: () => [] },
    summary: null,
    loading: { type: Boolean, default: false },
    toolStatus: null
  },
  emits: ['update:state', 'export', 'change-page'],
  setup(__props: any, { emit: emits }) {

const props = __props as { state: ProductionHistoryCardState, records: ProductionHistoryRecord[], summary?: {
      total: number
      returned: number
      page: number
      limit: number
      note: string
    }, loading: boolean, toolStatus?: 'running' | 'completed' | 'failed' }



const downloadableRecords = computed(() =>
  props.records.filter((record) => Boolean(record.downloadUrl))
)
const selectedCount = computed(() => props.state.selectedRecordIds.length)
const isAllSelected = computed(
  () =>
    downloadableRecords.value.length > 0 &&
    props.state.selectedRecordIds.length === downloadableRecords.value.length
)
const statusLabel = computed(() => {
  if (props.toolStatus === 'running') return '查询中'
  if (props.toolStatus === 'completed') return '已完成'
  if (props.toolStatus === 'failed') return '查询失败'
  return ''
})
const currentPage = computed(() => props.summary?.page || 1)
const totalPages = computed(() =>
  Math.max(
    1,
    Math.ceil((props.summary?.total || 0) / (props.summary?.limit || 1))
  )
)

function updateState(state: ProductionHistoryCardState) {
  emits('update:state', state)
}
function setAllSelected(selected: boolean) {
  if (props.state.exported) return
  updateState({
    ...props.state,
    selectedRecordIds: selected
      ? downloadableRecords.value.map((record) => record.id)
      : [],
  })
}
function toggleRecord(record: ProductionHistoryRecord) {
  if (props.state.exported || !record.downloadUrl) return
  const selectedRecordIds = props.state.selectedRecordIds.includes(record.id)
    ? props.state.selectedRecordIds.filter((id) => id !== record.id)
    : [...props.state.selectedRecordIds, record.id]
  updateState({ ...props.state, selectedRecordIds })
}

return { __sfc: true,props, emits, downloadableRecords, selectedCount, isAllSelected, statusLabel, currentPage, totalPages, updateState, setAllSelected, toggleRecord }
}

})